import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Spin, Select, InputNumber, Divider, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import BreadCrumb from "../../../layout/BreadCrumb";
import {
  fetchCounties,
  fetchData,
  fetchLocation,
  fetchSubCounties,
  fetchSubLocation,
} from "../../../features/fetch/fetchSlice";
import CardLoading from "../../../components/CardLoading";
import { schReclStatusData } from "../../../data";

const NegarimsAdd = () => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const urlHarvstng = "water_harvesting/fetch_waterharvestings";
  const urlPathway = "api/v2/irrigationPathway/get";
  const urlWard = "ward/fetch_wards";
  const urlConstituency = "constituency/fetch_constituencys";
  const urlTypography = "typography/fetch_typographys";
  const { counties, subCounties, locations, subLocations } = useSelector(
    (state) => state.fetch
  );
  const {
    loading,
    activeObjNegarim,
    dataHarvstng,
    dataPathway,
    dataConstituency,
    dataWard,
    dataTypography,
  } = useSelector((state) => ({
    activeObjNegarim: state.obj.activeObj["negarim"],
    dataHarvstng: state.fetch.data[urlHarvstng] || [],
    dataPathway: state.fetch.data[urlPathway] || [],
    dataWard: state.fetch.data[urlWard] || [],
    dataConstituency: state.fetch.data[urlConstituency] || [],
    dataTypography: state.fetch.data[urlTypography] || [],
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleCancel() {
    navigate("/rob/negarims");
  }
  const [negCountyId, setNegCountyId] = useState(
    activeObjNegarim?.negCountyId ?? ""
  );
  const [negConstId, setNegConstId] = useState(
    activeObjNegarim?.negConstId ?? ""
  );
  const [negSubCountyId, setNegSubCountyId] = useState(
    activeObjNegarim?.negSubCountyId ?? ""
  );
  const [negLocationId, setNegLocationId] = useState(
    activeObjNegarim?.negLocationId ?? ""
  );
  const [negSubLocationId, setNegSubLocationId] = useState(
    activeObjNegarim?.negSubLocationId ?? ""
  );
  const [negWardId, setNegWardId] = useState(activeObjNegarim?.negWardId ?? "");

  const handleNegCountyChange = async (value) => {
    setNegCountyId(value);
    setNegConstId("");
    setNegSubCountyId("");
    setNegLocationId("");
    setNegSubLocationId("");
    setNegWardId("");

    form.setFieldsValue({
      negCountyId: value,
      negConstId: "",
      negSubCountyId: "",
      negLocationId: "",
      negSubLocationId: "",
      negWardId: "",
    });

    await dispatch(fetchSubCounties({ subCountyId: value }));
    await dispatch(fetchData({ url: urlConstituency, constCountyId: value }));
  };

  const handleNegConstituencyChange = async (value) => {
    setNegConstId(value);
    setNegWardId("");

    form.setFieldsValue({
      negConstId: value,
      negWardId: "",
    });

    await dispatch(fetchData({ url: urlWard, wdConstId: value }));
  };

  const handleNegSubCountyChange = async (value) => {
    setNegSubCountyId(value);
    setNegLocationId("");
    setNegSubLocationId("");

    form.setFieldsValue({
      negSubCountyId: value,
      negLocationId: "",
      negSubLocationId: "",
    });

    await dispatch(fetchLocation({ locSubId: value }));
  };

  const handleNegLocationChange = async (value) => {
    setNegLocationId(value);
    setNegSubLocationId("");

    form.setFieldsValue({
      negLocationId: value,
      negSubLocationId: "",
    });

    await dispatch(fetchSubLocation({ slocLocId: value }));
  };

  const handleNegSubLocationChange = (value) => {
    setNegSubLocationId(value);
    form.setFieldsValue({ negSubLocationId: value });
  };

  const handleNegWardChange = (value) => {
    setNegWardId(value);
    form.setFieldsValue({ negWardId: value });
  };

  const onFinish = async (data) => {
    data.negId = activeObjNegarim?.negId ? activeObjNegarim?.negId : null;

    data.negPathwayId = Array.isArray(data?.negPathwayId)
      ? data?.negPathwayId.join(",")
      : data?.negPathwayId;

    const res = await dispatch(
      save({
        ...data,
        url: "negarim/save_negarim",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...activeObjNegarim,
    });
    if (activeObjNegarim?.negPathwayId) {
      form.setFieldsValue({
        negPathwayId: activeObjNegarim?.negPathwayId
          ?.split(",")
          ?.map((b) => b?.trim()),
      });
    }
  }, [activeObjNegarim, form]);

  const initialFormValues = {
    ...activeObjNegarim,
  };

  useEffect(() => {
    dispatch(fetchCounties());
    dispatch(
      fetchData({
        url: urlHarvstng,
        limit: null,
        start: 0,
      })
    );
    dispatch(
      fetchData({
        url: urlPathway,
        limit: null,
        start: 0,
      })
    );
    dispatch(
      fetchData({
        url: urlTypography,
        limit: null,
        start: 0,
      })
    );
  }, []);

  useEffect(() => {
    if (activeObjNegarim?.negId) {
      dispatch(
        fetchSubCounties({ subCountyId: activeObjNegarim?.negCountyId })
      );
      dispatch(
        fetchData({
          url: urlConstituency,
          constCountyId: activeObjNegarim?.negCountyId,
        })
      );
      dispatch(
        fetchData({ url: urlWard, wdConstId: activeObjNegarim?.negConstId })
      );
      dispatch(fetchLocation({ locSubId: activeObjNegarim?.negSubCountyId }));
      dispatch(
        fetchSubLocation({ slocLocId: activeObjNegarim?.negLocationId })
      );
    }
  }, [activeObjNegarim, form]);

  if (loading) return <CardLoading />;

  return (
    <div className="w-full ">
      <BreadCrumb
        breadcrumbs={[
          { title: "Negarims List", path: "/rob/negarims" },
          { title: "Negarim Add Form" },
        ]}
      />
      <div className="white_card mt-[2.06rem]">
        <div className="w-full">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className=""
            style={{
              maxWidth: "100%",
            }}
            form={form}
            initialValues={initialFormValues}
          >
            <div className="custom-title !bg-white !px-0">New Negarims</div>
            <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              <Form.Item
                name="negName"
                label={"Project Name"}
                rules={[
                  {
                    required: true,
                    message: "Please add project name",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="negStatus"
                className=""
                label={"Status"}
                rules={[
                  {
                    required: true,
                    message: "Please select status",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    schReclStatusData?.length > 0 &&
                    schReclStatusData?.map((item) => ({
                      value: item?.value,
                      label: item?.label,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                name="negCountyId"
                label="County"
                rules={[{ required: true, message: "Please select county" }]}
              >
                <Select
                  allowClear
                  options={counties?.map((c) => ({
                    value: c?.countyId,
                    label: c?.countyName,
                  }))}
                  onChange={handleNegCountyChange}
                  showSearch
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase()?.includes(input.toLowerCase())
                  }
                />
              </Form.Item>

              {negCountyId && (
                <>
                  <Form.Item
                    name="negConstId"
                    label="Constituency"
                    rules={[
                      { required: true, message: "Please select constituency" },
                    ]}
                  >
                    <Select
                      allowClear
                      options={dataConstituency?.map((c) => ({
                        value: c?.constId,
                        label: c?.constName,
                      }))}
                      onChange={handleNegConstituencyChange}
                      showSearch
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          ?.includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>

                  <Form.Item
                    name="negSubCountyId"
                    label="Subcounty"
                    rules={[
                      { required: true, message: "Please select subcounty" },
                    ]}
                  >
                    <Select
                      allowClear
                      options={subCounties?.map((s) => ({
                        value: s?.subId,
                        label: s?.subCountyName,
                      }))}
                      onChange={handleNegSubCountyChange}
                      showSearch
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          ?.includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </>
              )}

              {negSubCountyId && (
                <Form.Item
                  name="negLocationId"
                  label="Location"
                  rules={[
                    { required: true, message: "Please select location" },
                  ]}
                >
                  <Select
                    allowClear
                    options={locations?.map((l) => ({
                      value: l?.locId,
                      label: l?.locLocation,
                    }))}
                    onChange={handleNegLocationChange}
                    showSearch
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              )}

              {negLocationId && (
                <Form.Item
                  name="negSubLocationId"
                  label="Sublocation"
                  rules={[
                    { required: true, message: "Please select sublocation" },
                  ]}
                >
                  <Select
                    allowClear
                    options={subLocations?.map((sl) => ({
                      value: sl?.slocId,
                      label: sl?.slocLocation,
                    }))}
                    onChange={handleNegSubLocationChange}
                    showSearch
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              )}

              {negConstId && (
                <Form.Item
                  name="negWardId"
                  label="Ward"
                  rules={[{ required: true, message: "Please select ward" }]}
                >
                  <Select
                    allowClear
                    options={dataWard?.map((w) => ({
                      value: w?.wdId,
                      label: w?.wdWard,
                    }))}
                    onChange={handleNegWardChange}
                    showSearch
                    filterOption={(input, option) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              )}

              <Form.Item
                name="negLat"
                label={"Latitude (Decimal degrees, WGS84)"}
                rules={[
                  {
                    required: true,
                    message: "Please add latitude",
                  },
                ]}
              >
                <InputNumber
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="negLong"
                label={"Longitude (Decimal degrees, WGS84)"}
                rules={[
                  {
                    required: true,
                    message: "Please add longitude",
                  },
                ]}
              >
                <InputNumber
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  className="input flex"
                />
              </Form.Item>

              <Form.Item
                name="negSize"
                label={"Number of Negarims"}
                rules={[
                  {
                    required: true,
                    message: "Please add number of negarims",
                  },
                ]}
              >
                <InputNumber
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  className="input flex"
                />
              </Form.Item>

              <Form.Item
                name="negGroundSlopeId"
                className=""
                label={"Slope of The Ground"}
                rules={[
                  {
                    required: true,
                    message: "Please add slope of the ground",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataTypography?.length > 0 &&
                    dataTypography?.map((item) => ({
                      value: item?.typoId,
                      label: item?.typoTypography,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>

              <Form.Item
                name="negCatchmentArea"
                label={"Area of Acres"}
                rules={[
                  {
                    required: true,
                    message: "Please add area of acres",
                  },
                ]}
              >
                <InputNumber
                  suffix={"M"}
                  min={0}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  placeholder="Enter value"
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="negTreeTypeGrown"
                label={"Types of Trees Grown"}
                rules={[
                  {
                    required: true,
                    message: "Please ad types of trees grown",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="negWaterHarvestingId"
                className=""
                label={"Method of Water Harvesting,"}
                rules={[
                  {
                    required: true,
                    message: "Please select method of water harvesting,",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    dataHarvstng?.length > 0 &&
                    dataHarvstng?.map((item) => ({
                      value: item?.whId,
                      label: item?.whType,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                label={"Pathways"}
                name="negPathwayId"
                rules={[
                  {
                    required: true,
                    message: "Please add pathways",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch
                  dropdownRender={(menu) => (
                    <>
                      <Space style={{ padding: "8px 8px 4px" }}>
                        <span className="select-info mt-1">
                          Choose one or more of the following pathways
                        </span>
                      </Space>
                      <Divider style={{ margin: "8px 0" }} />
                      {menu}
                    </>
                  )}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.children?.toLowerCase() ?? "").includes(
                      input.toLowerCase()
                    )
                  }
                  dropdownStyle={{ maxHeight: 400, overflowY: "auto" }}
                >
                  {dataPathway?.length > 0 &&
                    dataPathway?.map((item) => (
                      <Select.Option
                        key={item?.irrigationPathwayId}
                        value={item?.irrigationPathwayId}
                      >
                        {item?.irrigationPathwayName}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </div>

            <div className="flex justify-between mt-[48px] ">
              <div className="justify-start"></div>
              <div className="justify-end flex items-center mb-[58px] gap-x-5">
                <div className="w-[150px]">
                  <button
                    type="button"
                    key="back"
                    onClick={handleCancel}
                    className="cstm-btn"
                  >
                    Cancel
                  </button>
                </div>

                <div className="w-[150px]">
                  <button key="submit" type="submit" className="cstm-btn-2">
                    {saving ? (
                      <Spin />
                    ) : activeObjNegarim?.negId ? (
                      "Update"
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
export default NegarimsAdd;
